const CashReconciliation = {
  CashReconciliation: "CashReconciliation.CashReconciliation",
  CashReconciliations: "CashReconciliation.CashReconciliations",
  StateFlowState_0: "CashReconciliation.StateFlowState_0",
  StateFlowState_1: "CashReconciliation.StateFlowState_1",
  StateFlowState_100: "CashReconciliation.StateFlowState_100",
  CashDifference: "CashReconciliation.CashDifference",
  Other: "CashReconciliation.Other",
  CreatedDailyTaking: "CashReconciliation.CreatedDailyTaking",
  DailyCashDate: "CashReconciliation.DailyCashDate",
  TagsHelpText: "CashReconciliation.TagsHelpText",
  CreateCashReconciliation: "CashReconciliation.CreateCashReconciliation",
  RegisteredBy: "CashReconciliation.RegisteredBy",
  Difference: "CashReconciliation.Difference",
  Sale: "CashReconciliation.Sale",
  AttachmentsHelpText: "CashReconciliation.AttachmentsHelpText",
  }
export default CashReconciliation;